import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M14.149 2c.023.165.051.329.051.5 0 .24-.027.473-.071.7H15.8V13H12v3.8H2.2V3.2h4.671a3.668 3.668 0 0 1-.071-.7c0-.171.028-.335.051-.5H1v16h12.2l3.8-3.8V2h-2.851zM13.2 16.303V14.2h2.103L13.2 16.303zM6.576 5.576l.849.848 1.79-1.79c.376.227.813.366 1.285.366A2.5 2.5 0 1 0 8 2.5c0 .472.139.909.366 1.285l-1.79 1.791zM10.5 1.2a1.301 1.301 0 0 1 0 2.6 1.301 1.301 0 0 1 0-2.6z" />
  </svg>
);

export default SvgComponent;
